import { getRequest, patchRequest } from '../request/request.service';
import { OUTBOUND_API } from './outbound-calls.constants';
import { Lead, LeadContact, NumberFlagsPayload } from './leads.service.types';

export function getLead(id: number) {
  return getRequest<Lead>(`${OUTBOUND_API}/leads/${id}`);
}

/** Only the flags are editable: the rest of a lead comes from the CSV. */
export function updateLeadFlags(id: number, payload: NumberFlagsPayload) {
  return patchRequest<Lead>(`${OUTBOUND_API}/leads/${id}`, { data: payload });
}

export function updateLeadContactFlags(id: number, payload: NumberFlagsPayload) {
  return patchRequest<LeadContact>(`${OUTBOUND_API}/lead_contacts/${id}`, { data: payload });
}
